import { PropTypeDenormalizedStrategy } from "fleet/prop-types/strategy";
import isEqual from "lodash/isEqual";
import PropTypes from "prop-types";
import React from "react";
import { Redirect } from "react-router-dom";
import { VIEW } from "view/views";

import { ConnectedStrategyV2Detail } from "./connected-detail";

class StrategyV2DetailController extends React.PureComponent {
  static get propTypes() {
    return {
      // UI State - denormalized strategy being edited.
      dnStrategy: PropTypeDenormalizedStrategy,
      id: PropTypes.string,
      // Unmodified denormalized strategy for reference.
      referenceDnStrategy: PropTypeDenormalizedStrategy,
      setUiStrategy: PropTypes.func.isRequired,
      storesLoaded: PropTypes.bool.isRequired,
      viewType: PropTypes.oneOf([VIEW.CLONE, VIEW.CREATE, VIEW.EDIT])
        .isRequired,
    };
  }

  static get defaultProps() {
    return {
      id: null,
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      initialized: false,
    };
  }

  componentDidUpdate(prevProps) {
    const { id, storesLoaded } = this.props;
  
    const routeChanged = id !== prevProps.id;
    const storesLoadedChanged =
      storesLoaded && storesLoaded !== prevProps.storesLoaded;
  
    if (routeChanged) {
      this.setState({ initialized: false }, () => {
        this._initStrategy(this.props);
      });
    }
  
    if (storesLoadedChanged) {
      this._initStrategy(this.props);
    }
  }

  componentDidMount() {
    this._initStrategy(this.props);
  }

  _initStrategy(props) {
    const { initialized } = this.state;
    const { viewType, setUiStrategy, storesLoaded, referenceDnStrategy } =
      props;

    if (initialized || !storesLoaded) {
      // We only initialize once.
      return;
    }

    // Prop referenceDnStrategy will be null if strategyId is invalid.
    if (referenceDnStrategy) {
      const name =
        viewType === VIEW.CLONE
          ? `Clone - ${referenceDnStrategy.name}`
          : referenceDnStrategy.name;

      setUiStrategy({
        ...referenceDnStrategy,
        name,
      });
    }

    this.setState({ initialized: true });
  }

  canSubmit() {
    // Check if we meet minimum validation to submit form.
    const { dnStrategy, referenceDnStrategy } = this.props;

    if (!dnStrategy) {
      return false;
    }

    const strategyModified = !isEqual(dnStrategy, referenceDnStrategy);
    return Boolean(strategyModified && dnStrategy.name && dnStrategy.main[0]);
  }

  render() {
    const { id, dnStrategy, viewType, referenceDnStrategy, storesLoaded } =
      this.props;
    const canSubmit = this.canSubmit();

    if (storesLoaded && !referenceDnStrategy) {
      return <Redirect to="/404" />;
    }

    return (
      <ConnectedStrategyV2Detail
        id={id}
        canSubmit={canSubmit}
        referenceDnStrategy={referenceDnStrategy}
        strategy={dnStrategy}
        storesLoaded={storesLoaded}
        viewType={viewType}
      />
    );
  }
}

export { StrategyV2DetailController };
